<template>
    <div>
        <!-- SELECT FISCAL YEARS -->
        <FiscalYearsSelect
            :fiscalYears="settings.fiscalyears"
            @updateFiscalYears="updateFiscalYears"
            @loaded="$emit('updateLoading', { loading: false })"
        />

        <!-- RADIO DISPLAY AMOUNT -->
        <el-form-item
            :label="
                $t.__(
                    'dashboard.forms.PurInvoiceSettingForm.select_display_total_invoice_amount_or_total_outstanding_amount',
                )
            "
            class="mb-4"
            prop="displayAmount"
        >
            <CompassRadioGroup v-model="form.displayAmount" direction="vertical">
                <CompassRadio modelValue="total" :label="$l10n.__('Total de la facture')" />
                <CompassRadio modelValue="due" :label="$l10n.__('Total restant dû (TTC)')" />
            </CompassRadioGroup>
        </el-form-item>
        <!-- RADIO TAX MODE -->
        <template v-if="form.displayAmount === 'total'">
            <el-form-item
                :label="$t.__('common.actions.select_tax_display')"
                class="mb-4"
                prop="taxMode"
            >
                <CompassRadioGroup v-model="form.taxMode" direction="vertical">
                    <CompassRadio modelValue="exc" :label="$l10n.__('HT')" />
                    <CompassRadio modelValue="inc" :label="$l10n.__('TTC')" />
                </CompassRadioGroup>
            </el-form-item>
        </template>
    </div>
</template>

<script>
import SettingsFormMixin from './SettingsFormMixin.js';
import FiscalYearsSelect from './FiscalYearsSelect.vue';

export default {
    components: {
        FiscalYearsSelect,
    },
    mixins: [SettingsFormMixin],
    data() {
        return {
            invoiceRules: {
                displayAmount: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
                taxMode: [
                    {
                        required: true,
                        message: this.$l10n.__("Veuillez sélectionner un mode d'affichage"),
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    created() {
        this.$emit('updateLoading', { loading: true });
    },
    mounted() {
        this.$emit('set-rules', this.invoiceRules);
    },
    methods: {
        close() {
            this.$emit('close-form');
        },
        updateFiscalYears(data) {
            this.form.fiscalyears = data;
        },
    },
};
</script>
